import { updateContext } from "@insite/client-framework/Context";
import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";

import {
    FulfillmentMethod,
    Session,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, UpdateContext } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        billToId?: string;
        shipToId?: string;
        fulfillmentMethod: string;
        pickUpWarehouse: WarehouseModel | null;
        isDefault?: boolean;
        returnUrl?: string;
        skipRedirect?: boolean;
    } & HasOnSuccess &
        HasOnError<string>,
    UpdateSessionApiParameter,
    Session,
    {
        cart: Cart;
    }
>;

export const UpdateContextCustom: HandlerType = props => {
    localStorage.removeItem("checkoutAccessorial");
    localStorage.removeItem("checkoutAccessorialCompleted");
    localStorage.removeItem("orderNotes");
};

addToChainAfter(chain, UpdateContext, UpdateContextCustom);
